var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var OfflineError = /** @class */ (function (_super) {
    __extends(OfflineError, _super);
    function OfflineError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, OfflineError.prototype);
        return _this;
    }
    return OfflineError;
}(Error));
export { OfflineError };
var ServerError = /** @class */ (function (_super) {
    __extends(ServerError, _super);
    function ServerError(status, message, serverError) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.serverError = serverError;
        Object.setPrototypeOf(_this, ServerError.prototype);
        return _this;
    }
    return ServerError;
}(Error));
export { ServerError };
